
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../node_modules/core-js/modules/es.array.reduce.js';
import '../../../node_modules/core-js/modules/es.object.keys.js';
import '../../../node_modules/core-js/modules/es.object.to-string.js';
import { configResponsive } from '../../../node_modules/ahooks/es/useResponsive/index.js';

var breakpoints = {
  xs: 320,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
  "3xl": 1920
};
var mq = Object.keys(breakpoints).reduce(function (acc, breakpointName) {
  return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, breakpointName, "@media screen and (min-width: ".concat(breakpoints[breakpointName], "px)")));
}, {});

// Configures useResponsive hook
configResponsive(breakpoints);

export { breakpoints, mq };
//# sourceMappingURL=breakpoints.js.map
